import React, {Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import UrlFilterForm from "../UrlFilterForm/UrlFilterForm";
import {createUrlFilterPolicy} from '../../../actions/actionFilters';

class CreateUrlFilter extends Component {
    constructor (props){
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="mt-4">
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Web Filter Policy</strong>
                                </CardHeader>
                                <UrlFilterForm
                                    createUrlFilterPolicy={this.props.createUrlFilterPolicy}/>
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


export default connect(state =>
        ({
            filters: state.filter.filters || [],
            categories: state.filter.categories || []
        }),
dispatch =>
    ({
        createUrlFilterPolicy: (data) => dispatch(createUrlFilterPolicy(data))
    }))(CreateUrlFilter);




// WEBPACK FOOTER //
// ./src/views/UrlFilter/CreateUrlFilter/CreateUrlFilter.js